const isOnboardingIncompleted = (onboardingCompleted?: string): boolean =>
  onboardingCompleted !== undefined &&
  onboardingCompleted !== null &&
  onboardingCompleted === 'false';

export { isOnboardingIncompleted };
